import { render } from "./KenyanPayrollSetup.vue?vue&type=template&id=6a49aa7f&scoped=true"
import script from "./KenyanPayrollSetup.vue?vue&type=script&lang=js"
export * from "./KenyanPayrollSetup.vue?vue&type=script&lang=js"

import "./KenyanPayrollSetup.vue?vue&type=style&index=0&id=6a49aa7f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a49aa7f"]])

export default __exports__